import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheetModule, MatBottomSheetRef } from '@angular/material/bottom-sheet';

import { HomeModule } from './../../home-page/home-page.module';
import { LoginBaseComponent } from './components/login-base/login-base.component';

import { MainForgotPasswordComponent } from './components/common/main-forgot-password/main-forgot-password.component';
import { MainMobileNumberComponent } from './components/common/main-mobile-number/main-mobile-number.component';
import { MainSignupComponent } from './components/common/main-signup/main-signup.component';
import { MainOtpVerificationComponent } from './components/common/main-otp-verification/main-otp-verification.component';
import { MainChangeNumberComponent } from './components/common/main-change-number/main-change-number.component';
import { GmailGenerateOtpComponent } from './components/common/gmail-generate-otp/gmail-generate-otp.component';

import { DesktopLoginWrapperComponent } from './components/desktop-components/desktop-login-wrapper/desktop-login-wrapper.component';
import { MobileNumberComponent } from './components/desktop-components/mobile-number/mobile-number.component';
import { SigninComponent } from './components/desktop-components/signin/signin.component';

import { MobileLoginWrapperComponent } from './components/mobile-components/mobile-login-wrapper/mobile-login-wrapper.component';
import { MobileLoginWithPasswordComponent } from './components/mobile-components/mobile-login-with-password/mobile-login-with-password.component';

@NgModule({
    imports: [
        CommonModule,
        HomeModule,
        MatDialogModule,
        MatBottomSheetModule,
        LoginBaseComponent,
        MainForgotPasswordComponent,
        MainMobileNumberComponent,
        MainSignupComponent,
        MainOtpVerificationComponent,
        MainChangeNumberComponent,
        MobileNumberComponent,
        SigninComponent,
        DesktopLoginWrapperComponent,
        MobileLoginWrapperComponent,
        MobileLoginWithPasswordComponent,
        GmailGenerateOtpComponent
    ],
    providers: [
        {
            provide: MatBottomSheetRef,
            useValue: {}
        }
    ],
    exports: [
        MatDialogModule,
        DesktopLoginWrapperComponent,
        MobileLoginWrapperComponent,
        MainForgotPasswordComponent,
        MainMobileNumberComponent,
        MainSignupComponent,
        MainOtpVerificationComponent,
        MainChangeNumberComponent,
        MobileLoginWithPasswordComponent,
        MobileNumberComponent,
        SigninComponent,
        GmailGenerateOtpComponent
    ]
})
export class AuthenticationModule {}
